import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST: 'LIST_BUILDING_SOLAR_ENERGY',
  CREATE: 'ADD_BUILDING_SOLAR_ENERGY',
  EDIT: 'EDIT_BUILDING_SOLAR_ENERGY',
  DELETE: 'DELETE_BUILDING_SOLAR_ENERGY',
  CLEAR_ERROR: 'CLEAR_ERROR_PROJECT',
};

export const listSolarEnergyInBuilding = (pageSize, page, sorted, filtered, isPublic, buildingId) => {
  return {
    type: ACTION.LIST,
    payload: RestClient.request({
      method: 'get',
      url: Constants.API_PROJECT_SOLAR_ENERGY,
      params: {
        search: filtered,
        limit: pageSize,
        offset: pageSize * page,
        ordering: sorted
          ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
          : null,
        is_public: isPublic,
        building_id: buildingId,
      }
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const addSolarEnergyToBuilding = (solarEnergyId, buildingId, quantity, azimuth, inclination) => {
  const data = {
    photovoltaic_id: solarEnergyId,
    building_id: buildingId,
    quantity: quantity,
    azimuth_angle: azimuth,
    inclination,
  };

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_PROJECT_SOLAR_ENERGY,
      data,
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const editSolarEnergyInBuilding = (buildingSolarEnergyId, quantity, azimuth, inclination) => {
  const data = {
    quantity,
    azimuth_angle: azimuth,
    inclination,
  };

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_PROJECT_SOLAR_ENERGY}${buildingSolarEnergyId}/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const removeSolarEnergyFromBuilding = (buildingSolarEnergyId, buildingId) => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_PROJECT_SOLAR_ENERGY}${buildingSolarEnergyId}/`,
    })
      .then(() => ({ id: buildingSolarEnergyId, building_id: buildingId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};



// WEBPACK FOOTER //
// ./src/redux/projects/project_solar_energy_actions.js